import { Routes } from '@angular/router';
import { AuthGuard } from './auth/services/auth.guard';
import { DashboardComponent } from './public/components/layout/dashboard/dashboard.component';
import { ErrorLayoutComponent } from '../shared/components/error-pages/error-layout/error-layout.component';
import { ERROR_ROUTES } from '../shared/constants/error-routes';
import { ValidCategoryGuard } from './guards/valid-category.guard';
import { ValidEventCategoryGuard } from './guards/valid-event-category.guard';

export const routes: Routes = [
    // Public Meta OAuth return URL (no AuthGuard) — must match Valid OAuth Redirect URIs
    {
      path: 'social-oauth/facebook',
      loadComponent: () =>
        import('./admin-panel/components/pages/social-media/components/facebook-oauth-callback/facebook-oauth-callback.component').then(
          (m) => m.FacebookOauthCallbackComponent
        ),
    },
    // Public X OAuth return URL (no AuthGuard) — must match X Callback URI
    {
      path: 'social-oauth/x',
      loadComponent: () =>
        import('./admin-panel/components/pages/social-media/components/x-oauth-callback/x-oauth-callback.component').then(
          (m) => m.XOauthCallbackComponent
        ),
    },
    // Public LinkedIn OAuth return URL (no AuthGuard)
    {
      path: 'social-oauth/linkedin',
      loadComponent: () =>
        import('./admin-panel/components/pages/social-media/components/linkedin-oauth-callback/linkedin-oauth-callback.component').then(
          (m) => m.LinkedInOauthCallbackComponent
        ),
    },
    // Error routes first so /error/404 and /error/500 are not matched as :category by public routes
    {
      path: 'error',
      component: ErrorLayoutComponent,
      children: [
        {
          path: '400',
          loadComponent: () =>
            import('../shared/components/error-pages/error-page-400/error-page-400.component').then(
              (m) => m.ErrorPage400Component
            ),
        },
        {
          path: '401',
          loadComponent: () =>
            import('../shared/components/error-pages/error-page-401/error-page-401.component').then(
              (m) => m.ErrorPage401Component
            ),
        },
        {
          path: '403',
          loadComponent: () =>
            import('../shared/components/error-pages/error-page-403/error-page-403.component').then(
              (m) => m.ErrorPage403Component
            ),
        },
        {
          path: '404',
          loadComponent: () =>
            import('../shared/components/error-pages/error-page-404/error-page-404.component').then(
              (m) => m.ErrorPage404Component
            ),
        },
        {
          path: '500',
          loadComponent: () =>
            import('../shared/components/error-pages/error-page-500/error-page-500.component').then(
              (m) => m.ErrorPage500Component
            ),
        },
      ],
    },
    {
      path: '',
      loadChildren: () =>
        import('./public/public-module').then((m) => m.PublicModule),
    },
    {
        path: 'auth',
        loadChildren: () =>
          import('./auth/auth.module').then((m) => m.AuthModule),
      },
      // Auth popup outlet – used by login-popup dialog (e.g. from icon-preview)
      {
        path: 'auth-popup',
        outlet: 'authPopup',
        loadChildren: () =>
          import('./auth/auth.module').then((m) => m.AuthModule),
      },
      {
        path: 'admin-panel',
        canActivate:[AuthGuard],
        loadChildren: () =>
          import('./admin-panel/admin-panel.module').then((m) => m.AdminPanelModule),
      },
      {
        path:'',
        component:DashboardComponent,
        loadChildren: () =>
          import('./public/components/pages/gallery/asset-gallery/asset-gallery.module').then((m) => m.AssetGalleryModule),
        
      },
      {
        path:'',
        component:DashboardComponent,
        children:[
          {
            path: ':eventCategoryName',
            canMatch: [ValidEventCategoryGuard],
            data: {
              showGallery: false,
            },
            loadChildren: () =>
              import('./public/components/pages/gallery/event-pack-gallery/event-pack-gallery.module').then(
                (m) => m.EventPackGalleryModule
              ),
          },
          {
            path:':category',
            canMatch: [ValidCategoryGuard],
            data:{
              showGallery:false
            },
            loadChildren: () =>
              import('./public/components/pages/gallery/pack-gallery/pack-gallery.module').then((m) => m.PackGalleryModule),
          },
          {
            path:':categoryName/:name/:pack',
            data:{
              showGallery:false
            },
            loadChildren: () =>
              import('./public/components/pages/gallery/icon-gallery/icon-gallery.module').then((m) => m.IconGalleryModule),
          },
        ]
      },
      // Unknown routes (not part of the app) → show 404 error page
      { path: '**', redirectTo: ERROR_ROUTES.notFound },
];
